<template>
  <div class="mood-modal-backdrop">
    <div id="mood_modal" class="mood-modal">
      <div class="mood-scrollbox">
        <span class="is-size-3 is-pulled-right has-text-right btn-close"><a @click="close"><i class="fas fa-times-circle"></i></a></span>





        
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
 .emoji-green {
  margin: 5px;
  font-size: 30pt;
  font-weight: bold;
  color: rgb(160, 223, 160);
}
.emoji-yellow {
  margin: 5px;
  font-size: 30pt;
  font-weight: bold;
  color: rgb(234, 234, 192);
}
.emoji-red {
  margin: 5px;
  font-size: 30pt;
  font-weight: bold;
  color: rgb(218, 158, 158);
}
.mood-info-box {
  padding-bottom: 20px;
  max-width: 280px; 
  margin: auto;
}
.mood-inner-box {
}
.mood-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-Index: 1000;
}
.mood-modal {
  font-family: Verdana;
  padding: 5px;
  border-radius: 25px !important;
  background-color: black;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 95%;
}
.mood-scrollbox {
  width: 100%;
  height: 100%;
  padding: 20px;
}
.mood-heading {
  font-family: '28 Days Later';
  font-size: 14pt;
  font-weight: bold;
  color: goldenrod;
}
.btn-close {
  font-size: 2em;
  padding-left: 10px;
  cursor: pointer;
  font-weight: bold;
  text-align: right;
}
</style>

<script>
export default {
  name: "MoodModal",
  data () {
    return {
      publicPath: process.env.BASE_URL,
      feel: '',
      changedText: '',
      focusText: '',
      goalText: '',
      workingNotesText: ''
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    setMood(mood) {
      //alert("mood: " + mood);
      this.feel = mood;
    },
    dismissMood() {
      this.$parent.gameData.mood = {};
      this.$emit("submitMood");
    },
    submitMood() {
      if (this.focusText.length > 400) {
        alert("'My Focus' text is too long (needs to be less than 400 characters)");
        return;
      }
      if (this.goalText.length > 400) {
        alert("'My Goals' text is too long (needs to be less than 400 characters)");
        return;
      }
      if (this.workingNotesText.length > 400) {
        alert("'Working Notes' text is too long (needs to be less than 400 characters)");
        return;
      }
      var moodData = {
        feel: this.feel,
        goalText: this.goalText,
        focusText: this.focusText,
        workingNotesText: this.workingNotesText
      }
      //console.log("moodData", moodData);
      this.$parent.gameData.mood = moodData;
      this.$emit("submitMood");
    },
  },
  mounted(){
  }
};
</script>
